import { formatTurnOpenDuration } from '../../../cash/app-api';
import { formatLocalTime } from '@shared/vueltoDateTime';

const DAY_MS = 24 * 60 * 60 * 1000;

export function isCashOpenStale(openedAt: string, nowMs = Date.now()): boolean {
  const openedMs = new Date(openedAt).getTime();
  if (!Number.isFinite(openedMs)) return false;
  return nowMs - openedMs >= DAY_MS;
}

/** Subtítulo de la fila de caja abierta: hora hoy vs duración si cruza días. */
export function homeCashOpenSubtitle(openedAt: string, nowMs = Date.now()): string {
  if (isCashOpenStale(openedAt, nowMs)) {
    // La duración ya dice "hace N días" — la fecha exacta vive en el detalle del turno.
    const duration = formatTurnOpenDuration(openedAt, nowMs).replace(/^Abierta\s+/i, '');
    return `${duration.charAt(0).toUpperCase()}${duration.slice(1)} · Ver turno`;
  }
  return `Abierta a las ${formatLocalTime(openedAt)} · Ver turno`;
}
